module.exports = __webpack_public_path__ + "static/media/parentbirth-popup.f6cf4401.png";